import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import StarIcon from '@material-ui/icons/Star';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Parser from 'html-react-parser';
/**
 * @Description This function lets you return Bot card component.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function Card({ data, selected, onClick }) {
    const { t } = useTranslation();
    const label = 'CONTENT.BOT.';
    const scrollmenu = useRef();

    useEffect(() => {
        let pos = { top: 0, left: 0, x: 0, y: 0 };
        const mouseDownHandler = function (e) {
            // Change the cursor and prevent user from selecting the text
            scrollmenu.current.style.userSelect = 'none';
            pos = {
                // The current scroll 
                left: scrollmenu.current.scrollLeft,
                top: scrollmenu.current.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
        };
        const mouseMoveHandler = function (e) {
            // How far the mouse has been moved
            const dx = e.clientX - pos.x;
            const dy = e.clientY - pos.y;

            // Scroll the element
            scrollmenu.current.scrollTop = pos.top - dy;
            scrollmenu.current.scrollLeft = pos.left - dx;
        };
        const mouseUpHandler = function () {
            scrollmenu.current.style.removeProperty('user-select');
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };
        scrollmenu.current.addEventListener('mousedown', mouseDownHandler);
        return () => {
            scrollmenu.current?.removeEventListener('mousedown', mouseDownHandler);
        }
    }, []);

    const handleClick = () => { onClick(data); }
    const dataTemp = {
        stars: [true, true, true, true, false],
        images: [
            { title: 'wp1', img:'https://i1.wp.com/gokhan-gokalp.com/wp-content/uploads/2016/05/PUZZLE-1-min.png' },
            { title: 'wp2', img:'https://i1.wp.com/gokhan-gokalp.com/wp-content/uploads/2016/05/PUZZLE-1-min.png' },
            { title: 'wp3', img:'https://i1.wp.com/gokhan-gokalp.com/wp-content/uploads/2016/05/PUZZLE-1-min.png' },
            { title: 'wp4', img:'https://i1.wp.com/gokhan-gokalp.com/wp-content/uploads/2016/05/PUZZLE-1-min.png' }
        ]
    };
    return (
        <div className="autom-container">
            <div className={`vbot-selection${selected ? ' vselected': ''}`}>
                <button onClick={handleClick}>{selected ? t(label + 'SELECTED') : t(label + 'SELECT')}</button>
            </div>
            <div className="autom-header">
                <div>{dataTemp?.stars?.map((item, itemI) => <StarIcon key={itemI} fontSize="small" style={{ color: item ? '#FFBE41' : '#C4C4C4' }} />)}</div>
                <div><MoreVertIcon fontSize="small" style={{ color: '#D4D4D4' }} /></div>
            </div>
            <div className="autom-body">
                <div className="filter-label">{data.name}</div>
                <div>
                    <div>
                        <div className="autom-label">{t(label + 'REQUIREMENTS')}</div>
                        <div className="autom-require"><div className="autom-img"></div><div className="autom-img"></div></div>
                    </div>
                    <div className="autom-requirement"></div>
                    <div>
                        <div className="autom-label">{t(label + 'PUBLISHER')}</div>
                        <div className="autom-publish"><div className="autom-img"></div></div>
                    </div>
                </div>
                <div>
                    <div className="autom-label">{t(label + 'RESOURCES')}</div>
                    <div>
                        <div ref={scrollmenu} className="vcard scrollmenu">
                            {data?.resources?.map((tile, index) => (
                                <div key={index} className="column">
                                    <img src={tile.thumbnail} alt="au-resource" style={{ width: '100%' }} draggable={false} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div>
                    <div className="autom-label">{t(label + 'DESCRIPTION')}</div>
                    <div className="autom-desc">{Parser(data?.short_description ? data.short_description : '')}</div>
                </div>
            </div>
        </div>
    )
}
export default Card;
